export var uuidToId = function (uuid) { return uuid.replace(/-/g, ''); };
//# sourceMappingURL=uuid-to-id.js.map